import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLabels, useFlags } from 'wsm-common-data';
import { ErrorBoundary } from 'wsm-error-boundary';
import { EvModal } from 'wsm-common-modal';
import QuickSpecs from '../components/QuickSpecs';
import { FLAG_ENABLE_EV_DETAIL_LINK } from '../global-constants';

const Widget = () => {
	const {
		quickSpecs,
		vehicleType,
		requestData: { deviceType },
		isElectric
	} = useSelector((state) => state);
	const [modalTitle, setModalTitle] = useState('');
	const [modalContent, setModalContent] = useState({});
	const [isOpenModal, setOpenModal] = useState(false);
	const [isMutilEvGroups, setMutilEvGroups] = useState(false);
	const labels = useLabels();
	const flags = useFlags();
	// flag show or hide detail links default is true
	const showEvDetailsLinkFlag = flags[FLAG_ENABLE_EV_DETAIL_LINK] || false;

	if (!quickSpecs) {
		return null;
	}

	const openQuickSpecModal = (
		modalTitleMarkup = '',
		modalContentMarkup = {},
		isMutilFacetGroupsMarkup = false
	) => {
		setOpenModal(true);
		setModalTitle(modalTitleMarkup);
		setModalContent(modalContentMarkup);
		setMutilEvGroups(isMutilFacetGroupsMarkup);
	};

	const closeModal = () => {
		setOpenModal(false);
	};

	const getEvModalOptions = () => {
		return {
			isOpen: isOpenModal,
			onClose: closeModal,
			onOpen: openQuickSpecModal,
			title: modalTitle,
			children: modalContent,
			isMutilFacetGroups: isMutilEvGroups
		};
	};

	const options = getEvModalOptions();

	return (
		<ErrorBoundary newRelicPageAction="WS QUICK SPECS ERROR BOUNDARY">
			{showEvDetailsLinkFlag && <EvModal {...options} />}
			<QuickSpecs
				quickSpecs={quickSpecs}
				deviceType={deviceType}
				vehicleType={vehicleType}
				isElectric={isElectric}
				labels={labels}
				onOpenModal={openQuickSpecModal}
			/>
		</ErrorBoundary>
	);
};

export default Widget;
